const Endpoints = {
  //---PERSONNEL AUTH---
  personnelRegister:
    "https://hemenpersonel-api.anemotech.com/personnel/auth/registerWeb",
  firmRegister: "https://hemenpersonel-api.anemotech.com/firm/auth/registerWeb",

  //---PERSONNEL AUTH---
  personnelValidateOTP: "personnel/auth/validateOTP",
  personnelGoogleAuth: "personnel/auth/googleAuthenticateWeb",
  personnelRenewPassword: "personnel/auth/renewPassword",

  //---AUTH LOGOUT---
  personnelLogout: "personnel/logout",
  firmLogout: "firm/logout",

  //---FIRM ---
  createFirmUser: "firm/user/create",
  getFirmInfo: "firm/firm/get",
  getFirmUsers: "firm/user/getAll",
  getFirmUserByUserId: "firm/user/getByUserId",
  updateFirmUser: "firm/user/updateOtherUser",
  updateFirm: "firm/firm/update",
  addFirmImage: "firm/firm/addImage",
  completeFirmInformation: "firm/firm/completeFirmInformation",

  //---FIRM ADVERT---
  firmAddAdvert: "firm/advert/add",
  getFirmAdverts: "firm/advert/getAll",
  filterFirmAdverts: "firm/advert/filter",
  getFirmAdvertById: "firm/advert/get",
  deleteFirmAdvert: "firm/advert/delete",
  updateFirmAdvert: "firm/advert/update",
  getAdressGeoCoding: "common/geocoding/getAddress",
  getSavedLocations: "firm/firmSavedLocation/getAll",

  //PERSONNEL ADVERT
  filterAdvert: "personnel/advert/filter",
  getAdvertPersonnel: "personnel/advert/get",
  favoriteAdvertPersonnel: "personnel/advert/favorite",
  unfavoriteAdvertPersonnel: "personnel/advert/unfavorite",
  applyAdvertPersonnel: "personnel/advert/apply",
  getSimilarAdverts: "personnel/advert/getSimilar",
  getFavoriteAdverts: "personnel/advert/getFavorite",
  getAppliedAdverts: "personnel/advert/getApplied",
  getAssignedAdverts: "personnel/advert/getAssigned",

  //---PERSONNEL KİŞİSEL BİLGİLER---
  updatePersonnelForeignLanguage:
    "personnel/user/updatePersonnelForeignLanguage",
  updatePersonnelExperience: "personnel/user/updatePersonnelExperience",
  updatePersonnelExam: "personnel/user/updatePersonnelExam",
  updatePersonnelEducation: "personnel/user/updatePersonnelEducation",
  updatePersonnelCourse: "personnel/user/updatePersonnelCourse",
  updatePersonnelComputerInformation:
    "personnel/user/updatePersonnelComputerInformation",
  updatePersonnelCertificate: "personnel/user/updatePersonnelCertificate",
  setPersonalInformation: "personnel/user/setPersonalInformation",
  setOnboarding: "personnel/user/setOnboarding",
  addPersonnelForeignLanguage: "personnel/user/addPersonnelForeignLanguage",
  addPersonnelExperience: "personnel/user/addPersonnelExperience",
  addPersonnelExam: "personnel/user/addPersonnelExam",
  addPersonnelEducation: "personnel/user/addPersonnelEducation",
  addPersonnelCourse: "personnel/user/addPersonnelCourse",
  addPersonnelComputerInformation:
    "personnel/user/addPersonnelComputerInformation",
  addPersonnelCertificate: "personnel/user/addPersonnelCertificate",
  addPersonnelCV: "personnel/user/addPersonnelCV",
  deletePersonnelExam: "personnel/user/deletePersonnelExam",
  deletePersonnelExperience: "personnel/user/deletePersonnelExperience",
  deletePersonnelEducation: "personnel/user/deletePersonnelEducation",
  deletePersonnelCourse: "personnel/user/deletePersonnelCourse",
  deletePersonnelComputerInformation:
    "personnel/user/deletePersonnelComputerInformation",
  deletePersonnelCertificate: "personnel/user/deletePersonnelCertificate",
  deletePersonnelForeignLanguage:
    "personnel/user/deletePersonnelForeignLanguage",
  addImage: "personnel/user/addImage",
  deleteImage: "personnel/user/deleteImage",
  getCvPreview: "personnel/user/getCVPreview",
  getCvPreviewPdf: "personnel/user/getCVPreviewPdf",

  //---PERSONNEL ---
  getPersonnel: "personnel/user/get",

  //---PERSONNEL DOCUMENT ---
  getFileFirmsPersonnel: "personnel/userFile/getFirms",
  getAllFilesPersonnel: "personnel/userFile/getAll",
  addFilePersonnel: "personnel/userFile/addFile",
  deleteFilePersonnel: "personnel/userFile/deleteFile",
  getAllFilesByFirmId: "personnel/userFile/getAllByFirmId",

  // //---FIRM DOCUMENT ---
  getFilePersonnelsFirm: "firm/userFile/getPersonnel",
  getAllFilesFirm: "firm/userFile/getAll",
  addFileFirm: "firm/userFile/addFile",
  deleteFileFirm: "firm/userFile/deleteFile",
  getAllFilesByPersonnelId: "firm/userFile/getAllByPersonnelId",
  getCvPreviewFirm: "firm/personnel/getCVPreview",
  getCvPreviewPdfFirm: "firm/personnel/getCVPreviewPdf",
  addTradeRegistry: "firm/firm/addTradeRegistry",
  addTaxCertificate: "firm/firm/addTaxCertificate",
  addSignature: "firm/firm/addSignature",

  //---COMMON---
  getCountries: "common/location/getCountries",
  getCities: "common/location/getCities",
  getDistricts: "common/location/getDistricts",
  getForeignLanguageLearnedPlatforms:
    "common/enum/getForeignLanguageLearnedPlatforms",
  getFirmRoles: "common/enum/getFirmRoles",
  getEducationTypes: "common/enum/getEducationTypes",
  getKnowledgeLevels: "common/enum/getKnowledgeLevels",
  getYearsOfExperiences: "common/enum/getYearsOfExperiences",
  getSchoolTypes: "common/enum/getSchoolTypes",
  getMaritalStatutes: "common/enum/getMaritalStatuses",
  getGenders: "common/enum/getGenders",
  getCompletionStatuses: "common/enum/getCompletionStatuses",
  getAllForeignLanguages: "common/foreignLanguage/getAll",
  getAllEducationLanguages: "common/educationLanguage/getAll",
  getForeignLanguage: "common/foreignLanguage/get",
  getAllComputerInformation: "common/computerInformation/getAll",
  getComputerInformation: "common/computerInformation/get",
  getAllSectors: "common/sector/getAll",
  getAllPositions: "common/jobPosition/getAll",
  getAllJobOptionCategories: "common/jobOptionCategory/getAll",
  getAllJobOptions: "common/jobOptionCategory/getAll",
  getAllLabelKeys: "common/enum/getLabelKeys",
  getAllJobTypes: "common/enum/getJobTypes",
  getAllDurationTypes: "common/enum/getDurationTypes",
  getAllWageTypes: "common/enum/getWageTypes",
  getAllDepartments: "common/department/getAll",
  getAllFirmRoles: "common/enum/getFirmRoles",
  getAllWagePeriods: "common/enum/getWagePeriods",
};

export default Endpoints;
